import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';
import FullScreenMessage from '../../components/common/FullScreenMessage/FullScreenMessage';
import { FiAlertTriangle } from 'react-icons/fi';

const NotFoundPage = () => {
    const navigate = useNavigate();
    const intl = useIntl();

    return (
        <FullScreenMessage
            icon={<FiAlertTriangle size={48} />}
            title={intl.formatMessage({ id: "notFound.title" })}
            text={intl.formatMessage({ id: "notFound.text" })}
            buttonProps={{
                text: intl.formatMessage({ id: "notFound.button" }),
                onClick: () => navigate('/'), // Кнопка ведет на главную страницу
            }}
        />
    );
};

export default NotFoundPage;
